// export const ip = 'iotapp.test.api.tokiot.cn'// 智慧用电 测试
// export const ip = 'se.api.tokiot.cn'// 智慧用电 测试
// export const ip = 'se.api.tokiot.cn'// 智慧用电 生产
// export const port = '38071'
// export const port = '80'
// export const port = '8081'
export const clientVersion = "V2.0.0.20260515.cluster"; // 程序版本

// 新驱动 测试
// export const ip = '192.168.1.253'
// export const port = '8080'

// 新驱动 开发
// export const ip = '121.204.186.158'
// export const port = '34001'

export const htmeTitle = "智慧消防";

// export const baseUrl = 'http://' + ip + ':' + port
export const baseUrl = "/se-api-prod"; // 生产
// export const baseUrl = '/se-api-test' // 测试
export const flvApiUrl = "/flv-api/"; // 播放器地址

//上传图片
export const uploadImg = baseUrl + "/api/other/upload";
export const getWSUrl = (username) =>
  `${"https:" == window.location.protocol ? "wss" : "ws"}://${
    window.location.host
  }${baseUrl}/ws/${username}/web`;

// export const stompUrl = `http://${window.location.host}${baseUrl}/wsmb`;
export const stompUrl = `http://se.api.tokiot.cn/wsmb`;

//查看图片
export const downloadImg = baseUrl + "/api/other/download-image-stream?fileId=";

//语音报警文件
export const voiceUrl = baseUrl + "/api/other/download-audio-stream?fileId=";

//上传字体图标图片
export const uploadIconImg = baseUrl + "/api/other/upload-product-icon-image";

//下载导入结果
export const downExcel = baseUrl + "/api/device/download-result";

//获取图片验证码
export const captchaImage =
  baseUrl + "/captcha/image?width=109&height=40&imageRandom=";

//高德地图JSkey
export const amapKey = "26bc2e7a0f5a7db5224ad5f0573210da";
export const amapStyle1 = "darkblue";
export const amapStyle2 = "darkblue";

export const serviceKey = "4a0829fb561fdf84a1e208c0c6e4ae1d";

//科大讯飞语音合成appId
export const appId = "5c87952d";

//科大讯飞语音合成apiKey
export const apiKey = "61ca4fb463f51b79d34bbb4e9f880977";

//属性图标
export const propsIcon = [
  "icon-leixing1",
  "icon-ID",
  "icon-leixing",
  "icon-yijihuo",
  "icon-mingcheng",
  "icon-zaixian",
  "icon-banben",
  "icon-dianya1",
  "icon-wendu",
  "icon-yunhangshijian",
  "icon-liangdu",
  "icon-jiaodu",
  "icon-kaiguan",
  "icon-icon-power-power",
  "icon-dianliang",
  "icon-fengmingqi",
  "icon-humidity",
  "icon-maibomaichongxintiaoxindianpulse",
  "icon-chaifen",
  "icon-guanyu",
  "icon-dianya",
  "icon-fuweidaohuangchijiaojiao",
  "icon-xinzaobi",
  "icon-wulianwang",
  "icon-IMSI",
  "icon-qishibianhao",
  "icon-gongshangzhucehao",
  "icon-zhiwensuo",
  "icon-icon-electricity",
  "icon-liuliang1",
  "icon-liuliang",
  "icon-icon-detector",
  "icon-liuliangshuju",
  "icon-dianchi-",
  "icon-xinhao",
  "icon-xintiao",
  "icon-liuliangcopy",
  "icon-tongtouzhijing",
  "icon-shijian1",
  "icon-icon220",
  "icon-220vdianyachazuo",
  "icon-shujuguanlisvg29",
  "icon-tzddiyaxianlu",
  "icon-lock",
  "icon-dizhi",
  "icon-shanguangdeng",
  "icon-liuliangchongzhi",
  "icon-xuanzhuan",
  "icon-sn",
  "icon-yibiao",
];

//事件图标
export const eventsIcon = [
  "icon-zhuangtai",
  "icon-shanchu",
  "icon-dianchi",
  "icon-jishuiyuce",
  "icon-fangchaibaojing",
  "icon-dengpao-guzhang",
  "icon-tongyonglei_IOjiechubaojing",
  "icon-eyigongjilian",
  "icon-xitongzijian",
  "icon-shangbao1",
  "icon-shangbao",
  "icon-yalibaojing",
  "icon-weijianceshuliang",
  "icon-weixie",
  "icon-yishilian",
  "icon-tubiao-ditu-huozaibaojingqi",
  "icon-mute",
  "icon-guzhang",
  "icon-bumingjinggai",
  "icon-shilian",
  "icon-zhinengsuo",
  "icon-shuijing",
  "icon-shijian",
  "icon-yanwubaojing",
  "icon-shujuguanlisvg85",
  "icon-dwdjing",
  "icon-huifu",
  "icon-swbj",
  "icon-64",
  "icon-pohuailindi",
  "icon-huojing",
  "icon-dianliang",
  "icon-chaifen",
  "icon-dianchi-",
  "icon-xintiao",
  "icon-tzddiyaxianlu",
];
